import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  title: 'BOLT TestHub',
  production: false,
  ngxLogger: {
    serverLoggingLevel: NgxLoggerLevel.DEBUG,
    serverLoggingUrl: 'api/log',
    disableConsoleLogging: false,
    consoleLogLevel: NgxLoggerLevel.INFO,
  },
  errorMessage: 'Oops something went wrong!',
  useMockData: false,
  testHubApiUrl: 'https://medone-bolt-testhub-api-dev.azurewebsites.net/api',
  loginApiUrl: 'https://medone-bolt-testhub-loginapi-dev.azurewebsites.net/api/v1',
  msalConfig: {
    auth: {
      clientId: '26d57e2a-e4f8-4929-b009-2b21048bbba1',
      authority:
        'https://medonesystemsbolttesthub.ciamlogin.com/f4ba39c7-7142-44a8-905c-df857c30ba48',
      redirectUri: 'https://medone-bolt-testhub-ui-dev.medonesystems.com',
    },
  },
  loginApiConfig: {
    endpoint: 'api://94fe5930-48ee-4ba5-9892-b9f203673b32',
    scopes: ['api://94fe5930-48ee-4ba5-9892-b9f203673b32/user.read', 'profile', 'openid', 'email'],
  },
};
